<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Corporate Deals Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item active">Add Corporate Deal</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">Add Corporate Deal</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/corporate-deals" class="btn btn-light me-2">Cancel</a>
            <button type="button" class="btn btn-primary" (click)="submit()">Add Corporate Deal</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="partnerId">Partner ID <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="partnerId" name="partner_id" [(ngModel)]="form.partner_id"
                     [ngClass]="{'is-invalid': !form.partner_id && validationTriggered, 'is-valid': validationTriggered && form.partner_id}"
                     placeholder="e.g. P-001">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="corporateId">Corporate ID</label>
              <input type="text" class="form-control" id="corporateId" name="corporate_id" [(ngModel)]="form.corporate_id">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="dealName">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="dealName" name="name" [(ngModel)]="form.name"
                     [ngClass]="{'is-invalid': !form.name && validationTriggered, 'is-valid': validationTriggered && form.name}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="countdownMinutes">Countdown Minutes <span class="text-danger">*</span></label>
              <input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control" id="countdownMinutes" name="countdown_minutes"
                     [(ngModel)]="form.countdown_minutes" (input)="onCountdownMinutesInput($event)"
                     [ngClass]="{'is-invalid': (form.countdown_minutes === '' || form.countdown_minutes === null) && validationTriggered, 'is-valid': validationTriggered && form.countdown_minutes !== '' && form.countdown_minutes !== null}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="dealStatus">Status <span class="text-danger">*</span></label>
              <select class="form-select" id="dealStatus" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
